import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MobileLayout from "@/components/layouts/MobileLayout.vue";
import SharePage from "@/components/share/SharePage.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ShareView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MobileLayout, null, {
    default: _withCtx(() => [
      _createVNode(SharePage)
    ]),
    _: 1
  }))
}
}

})